import { DocumentNode, gql } from '@apollo/client'

export const USE_AUTO_LINK: DocumentNode = gql`
    mutation UseAutoLink($autoLink: String!) {
        useAutoLink(auto_link: $autoLink)
    }
`

export const RESET_AUTO_LINK: DocumentNode = gql`
    mutation ResetAutoLink($daycareId: Int!) {
        resetAutoLink(daycareId: $daycareId)
    }
`

export const ACTIVE_AUTO_LINK: DocumentNode = gql`
    mutation ActiveAutoLink($daycareId: Int!) {
        activeAutoLink(daycareId: $daycareId)
    }
`

export const DEACTIVE_AUTO_LINK: DocumentNode = gql`
    mutation DeactiveAutoLink($daycareId: Int!) {
        deactiveAutoLink(daycareId: $daycareId)
    }
`

export const GET_AUTO_LINK_MAIL: DocumentNode = gql`
    mutation GetAutoLinkMail($daycareId: Int!, $inviteParent: Boolean) {
        getAutoLinkMail(daycare_id: $daycareId, inviteParent: $inviteParent)
    }
`
